import { Button, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import http from "../../http";
import Countdown from "../countdown/Countdown";
import ReactCodeInput from 'react-verification-code-input-2';

export default function Login() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [phoneState, setPhoneState] = useState(false);
    const [code, setCode] = useState('');
    const [phone, setPhone] = useState('');

    const countdown = useRef<any>();

    const handleChangePhoneText = (e: any) => {
        setPhone(e.target.value);
    }

    const handleEditPhoneClick = () => {
        setPhoneState(false);
    }

    const verifyCode = () => {
        http({
            url: '/login/verify_code',
            method: 'post',
            data: {
                phone,
                code,
            }
        }).then(res => {
            if (res.data.success) {
                localStorage.setItem(process.env.REACT_APP_TOKEN_NAME ?? 'token', res.data.result);
                http.defaults.headers.common['authorization'] = `Bearer ${res.data.result}`;
                navigate(`/auth${window.location.search}`)
            }
            // TODO handle res.data.success false
        }).catch(err => {
            // TODO handle error
        })
    }

    const sendCode = () => {
        http({
            url: '/login/send_code',
            method: 'post',
            data: {
                phone,
            }
        }).then(res => {
            countdown.current.start();
            setPhoneState(res.data.success);
            // TODO handle res.data.success false
        }).catch(err => {
            // TODO handle error
        })
    }

    const handleNextClick = () => {
        if (phoneState) {
            verifyCode();
        } else {
            sendCode();
        }
    }

    const handleCompleteCode = (value: string) => {
        setCode(value);
    }

    const enabled: boolean = phoneState ? code.length > 0 : phone.length === 11;
    return (
        <div className="max-w-md flex flex-col grow h-full">
            <div style={{ direction: 'ltr' }} className="grow flex flex-col text-center justify-center">
                <Typography>{t('enter_phone')}</Typography>
                <input className="textfield mt-3" type='text' disabled={phoneState} onChange={handleChangePhoneText} placeholder="09&lowast;&lowast;  &lowast;&lowast;&lowast;  &lowast;&lowast;&lowast;&lowast;" />
                <div style={{ visibility: phoneState ? 'visible' : 'hidden' }} className="mt-2">
                    <Button onClick={handleEditPhoneClick}>{t('edit_phone')}</Button>
                </div>
                <div style={{ visibility: phoneState ? 'visible' : 'hidden' }} className="mt-14">
                    <ReactCodeInput className="w-full" type='number' fields={4} fieldWidth={70} fieldHeight={60} onComplete={handleCompleteCode}/>
                </div>
                <div style={{ visibility: phoneState ? 'visible' : 'hidden', direction: 'rtl' }} className="mt-4">
                    <Countdown ref={countdown} date={120} render={(date: string) => <Typography className='h-9 pt-2' color='textSecondary'>{t('remain_before_resend', {date})}</Typography>}>
                        <Button onClick={sendCode}>{t('resend_code')}</Button>
                    </Countdown>
                </div>
            </div>
            <Button className={enabled ? 'btn' : ''} disabled={!enabled} variant="contained" onClick={handleNextClick}>{phoneState ? t('login') : t('accept')}</Button>
        </div>
    )
}
